import React from 'react';
import eyeImg from '../../../assets/img/eye.png';
import tickImg from '../../../assets/img/checked.png';
import newImg from '../../../assets/img/new1.png';
import Img from '../../ImageLoader/ImageLoader';

export const NewLayerIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M22 6v16h-16v-16h16zm2-2h-20v20h20v-20zm-24-4v20h2v-18h18v-2h-20zm18 13h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2z' />
  </svg>
);

export const LayoutIcon = () => (
  <svg
    width='26'
    height='26'
    viewBox='0 0 40 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0)'>
      <path
        d='M35.6104 40H4.38364C3.22097 39.9969 2.1069 39.5332 1.28531 38.7105C0.463731 37.8878 0.00156906 36.7731 0 35.6104L0 4.38364C0.00314558 3.22097 0.466818 2.1069 1.28952 1.28531C2.11221 0.463731 3.22691 0.00156906 4.38959 0L35.6164 0C36.779 0.00314558 37.8931 0.466818 38.7147 1.28952C39.5363 2.11221 39.9984 3.22691 40 4.38959V35.6164C39.9969 36.779 39.5332 37.8931 38.7105 38.7147C37.8878 39.5363 36.7731 39.9984 35.6104 40V40ZM4.38959 1.18959C3.54114 1.19038 2.72766 1.52777 2.12772 2.12772C1.52777 2.72766 1.19038 3.54114 1.18959 4.38959V35.6164C1.19273 36.4635 1.53107 37.275 2.13068 37.8735C2.73029 38.472 3.54241 38.8088 4.38959 38.8104H35.6164C36.4646 38.8088 37.2776 38.4712 37.8774 37.8714C38.4771 37.2716 38.8148 36.4586 38.8164 35.6104V4.38364C38.814 3.53519 38.4751 2.72234 37.874 2.12351C37.273 1.52468 36.4589 1.1888 35.6104 1.18959H4.38959Z'
        fill='black'
        fillOpacity='0.5'
      />
      <path
        d='M2.03743 38.3643L1.03223 37.7279C1.24338 37.3948 6.24561 29.6 11.3579 29.3591C13.8203 29.2402 15.9675 30.2513 18.0434 31.2149C20.3274 32.2855 22.4865 33.2967 25.0055 32.8803C27.0872 32.5383 28.9579 31.4171 30.778 30.3316C33.3296 28.8089 35.9675 27.2327 39.2359 27.6907L39.0724 28.8803C36.2174 28.4818 33.8709 29.8825 31.3876 31.3636C29.4724 32.5086 27.4947 33.6892 25.1988 34.0639C22.314 34.5398 19.8872 33.4037 17.5378 32.3063C15.5066 31.3547 13.5854 30.4565 11.4144 30.5606C6.90881 30.7599 2.08204 38.287 2.03743 38.3643Z'
        fill='black'
        fillOpacity='0.5'
      />
      <path
        d='M39.322 11.5599C36.459 11.5567 33.7142 10.418 31.6897 8.39358C29.6653 6.36915 28.5266 3.62433 28.5234 0.761353H29.713C29.7154 3.30907 30.7285 5.75177 32.53 7.55328C34.3315 9.35479 36.7742 10.3679 39.322 10.3703V11.5599Z'
        fill='black'
        fillOpacity='0.5'
      />
      <path
        d='M23.0632 23.2298H8.92193C8.49884 23.2281 8.08362 23.1153 7.71784 22.9027C7.35206 22.69 7.04856 22.385 6.83775 22.0182C6.62693 21.6514 6.51618 21.2356 6.5166 20.8125C6.51702 20.3894 6.62859 19.9739 6.84014 19.6075L13.8914 7.34871C14.1037 6.98127 14.4089 6.67615 14.7764 6.46401C15.1439 6.25188 15.5608 6.1402 15.9851 6.1402C16.4095 6.1402 16.8263 6.25188 17.1938 6.46401C17.5614 6.67615 17.8666 6.98127 18.0788 7.34871L25.1539 19.6075C25.3654 19.9739 25.477 20.3894 25.4774 20.8125C25.4779 21.2356 25.3671 21.6514 25.1563 22.0182C24.9455 22.385 24.642 22.69 24.2762 22.9027C23.9104 23.1153 23.4952 23.2281 23.0721 23.2298H23.0632ZM14.9234 7.94351L7.84535 20.2022C7.73713 20.3896 7.68047 20.6024 7.68114 20.8188C7.68181 21.0352 7.73978 21.2476 7.84916 21.4343C7.95854 21.621 8.11542 21.7754 8.30385 21.8819C8.49228 21.9883 8.70554 22.0429 8.92193 22.0402H23.0781C23.2932 22.0403 23.5046 21.9837 23.6909 21.8762C23.8773 21.7687 24.032 21.6141 24.1396 21.4278C24.2472 21.2415 24.3039 21.0302 24.3039 20.815C24.304 20.5999 24.2473 20.3886 24.1398 20.2022L17.0468 7.94351C16.9394 7.75697 16.7847 7.60203 16.5983 7.4943C16.4119 7.38657 16.2004 7.32985 15.9851 7.32985C15.7698 7.32985 15.5584 7.38657 15.372 7.4943C15.1856 7.60203 15.0309 7.75697 14.9234 7.94351V7.94351Z'
        fill='black'
        fillOpacity='0.5'
      />
    </g>
  </svg>
);

export const ShapesIcon = () => (
  <div className='tooltip-secondary bottom' data-tip='Insert shapes'>
    <svg width='27' height='26' viewBox='0 0 27 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.5112 12.2383H23.1792C23.5999 12.2383 23.9409 11.8972 23.9409 11.4766V3.80859C23.9409 3.38792 23.5999 3.04688 23.1792 3.04688H15.5112C15.0906 3.04688 14.7495 3.38792 14.7495 3.80859V11.4766C14.7495 11.8972 15.0906 12.2383 15.5112 12.2383ZM16.2729 4.57031H22.4175V10.7148H16.2729V4.57031ZM10.7719 13.9849C10.6291 13.842 10.4353 13.7617 10.2333 13.7617H7.02746C6.82545 13.7617 6.63172 13.842 6.48887 13.9849L4.2578 16.2159C4.11495 16.3587 4.03467 16.5525 4.03467 16.7545V19.9604C4.03467 20.1624 4.11495 20.3561 4.2578 20.499L6.48887 22.73C6.63172 22.8729 6.82545 22.9532 7.02746 22.9532H10.2333C10.4353 22.9532 10.6291 22.8729 10.7719 22.73L13.0029 20.499C13.1458 20.3561 13.2261 20.1624 13.2261 19.9604V16.7545C13.2261 16.5525 13.1458 16.3588 13.0029 16.2159L10.7719 13.9849ZM11.7026 19.6448L9.91783 21.4297H7.34297L5.55811 19.6448V17.07L7.34297 15.2852H9.91783L11.7026 17.07V19.6448ZM12.7153 6.06623L10.2972 5.87102L9.36081 3.58155C9.24452 3.29728 8.96893 3.11066 8.6618 3.10822C8.35458 3.1071 8.07614 3.28804 7.95539 3.57043L6.9718 5.87041L4.54543 6.06628C4.23891 6.09101 3.97734 6.29759 3.88227 6.58998C3.78721 6.88243 3.8773 7.20332 4.11064 7.40355L5.95481 8.9861L5.39276 11.3506C5.32192 11.6485 5.43643 11.9599 5.68338 12.141C5.93033 12.3221 6.26173 12.3377 6.52457 12.1806L8.6517 10.9094L10.7302 12.177C10.9899 12.3354 11.323 12.3257 11.5745 12.143C11.8232 11.9623 11.939 11.6497 11.8679 11.3506L11.3058 8.9861L13.15 7.40355C13.3833 7.20332 13.4734 6.88243 13.3784 6.58998C13.2834 6.29754 13.0218 6.09096 12.7153 6.06623ZM9.96135 8.13236C9.74492 8.31807 9.65036 8.60915 9.71633 8.88662L9.96313 9.92479L9.05236 9.36934C8.811 9.22208 8.50778 9.22076 8.265 9.36579L7.29229 9.94703L7.54436 8.88657C7.61033 8.6091 7.51577 8.31807 7.29934 8.13231L6.48979 7.43763L7.55264 7.35186C7.83448 7.32911 8.08056 7.15208 8.19172 6.89213L8.64002 5.84375L9.06425 6.88096C9.17292 7.1467 9.42185 7.32875 9.708 7.35186L10.7709 7.43763L9.96135 8.13236ZM24.7026 0H3.27295C2.01291 0 0.987793 1.02512 0.987793 2.28516V23.7148C0.987793 24.9749 2.01291 26 3.27295 26H24.7026C25.9627 26 26.9878 24.9749 26.9878 23.7148V2.28516C26.9878 1.02512 25.9627 0 24.7026 0V0ZM25.4644 23.7148C25.4644 24.1349 25.1226 24.4766 24.7026 24.4766H3.27295C2.85294 24.4766 2.51123 24.1349 2.51123 23.7148V2.28516C2.51123 1.86514 2.85294 1.52344 3.27295 1.52344H24.7026C25.1226 1.52344 25.4644 1.86514 25.4644 2.28516V23.7148ZM21.2394 13.6855C20.3831 13.6855 19.7518 14.0945 19.3198 14.5359C18.8878 14.0945 18.2565 13.6855 17.4002 13.6855C16.6633 13.6855 15.3514 14.277 14.8761 15.5465C13.9363 18.0571 16.8008 21.0079 18.8196 22.7658C18.9629 22.8907 19.1414 22.9531 19.3198 22.9531C19.4983 22.9531 19.6767 22.8907 19.8201 22.7658C21.835 21.0114 24.7333 18.0376 23.7935 15.5272C23.3179 14.2569 22.0136 13.6855 21.2394 13.6855ZM19.3199 21.1708C16.0342 18.1638 16.1039 16.6263 16.2992 16.0906C16.5329 15.4492 17.2409 15.2117 17.4003 15.209C18.1014 15.209 18.5253 15.9478 18.6385 16.1742C18.7676 16.4323 19.0313 16.5953 19.3198 16.5953C19.6083 16.5953 19.8721 16.4323 20.0011 16.1742C20.1143 15.9478 20.5383 15.2089 21.2394 15.2089C21.4694 15.2089 22.1426 15.4625 22.3668 16.0613C22.5666 16.5952 22.6425 18.1326 19.3199 21.1708Z'
        fill='#000000'
        fillOpacity='0.5'
      />
    </svg>
  </div>
);

export const RightArrowIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M21 12l-18 12v-24z' />
  </svg>
);

export const BackgroundIcon = () => (
  <div className='tooltip-secondary bottom' data-tip='Choose background'>
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.8144 0L0.987793 12.8267V16.9144L17.9022 0H13.8144Z'
        fill='#000000'
        fillOpacity='0.5'
      />
      <path
        d='M3.8767 0C2.28779 0 0.987793 1.3 0.987793 2.88891V5.785L6.77279 0H3.8767Z'
        fill='#000000'
        fillOpacity='0.5'
      />
      <path
        d='M10.0732 26H14.161L26.9877 13.1733V9.08557L10.0732 26Z'
        fill='#000000'
        fillOpacity='0.5'
      />
      <path
        d='M24.8356 0.108337L1.09619 23.8478C1.22619 24.3461 1.47895 24.7938 1.83286 25.1478L1.8401 25.155C2.19401 25.5089 2.64177 25.7617 3.1401 25.8917L26.8795 2.15225C26.6123 1.15558 25.8323 0.375582 24.8356 0.108337Z'
        fill='#000000'
        fillOpacity='0.5'
      />
      <path
        d='M24.0987 26C24.8931 26 25.6154 25.675 26.1354 25.155C26.6626 24.6278 26.9876 23.9056 26.9876 23.1111V20.215L21.2026 26H24.0987Z'
        fill='#000000'
        fillOpacity='0.5'
      />
    </svg>
  </div>
);

export const OptionsIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M17 10.645v-2.29c-1.17-.417-1.907-.533-2.28-1.431-.373-.9.07-1.512.6-2.625l-1.618-1.619c-1.105.525-1.723.974-2.626.6-.9-.373-1.017-1.116-1.431-2.28h-2.29c-.412 1.158-.53 1.907-1.431 2.28h-.001c-.9.374-1.51-.07-2.625-.6l-1.617 1.619c.527 1.11.973 1.724.6 2.625-.375.901-1.123 1.019-2.281 1.431v2.289c1.155.412 1.907.531 2.28 1.431.376.908-.081 1.534-.6 2.625l1.618 1.619c1.107-.525 1.724-.974 2.625-.6h.001c.9.373 1.018 1.118 1.431 2.28h2.289c.412-1.158.53-1.905 1.437-2.282h.001c.894-.372 1.501.071 2.619.602l1.618-1.619c-.525-1.107-.974-1.723-.601-2.625.374-.899 1.126-1.019 2.282-1.43zm-8.5 1.689c-1.564 0-2.833-1.269-2.833-2.834s1.269-2.834 2.833-2.834 2.833 1.269 2.833 2.834-1.269 2.834-2.833 2.834zm15.5 4.205v-1.077c-.55-.196-.897-.251-1.073-.673-.176-.424.033-.711.282-1.236l-.762-.762c-.52.248-.811.458-1.235.283-.424-.175-.479-.525-.674-1.073h-1.076c-.194.545-.25.897-.674 1.073-.424.176-.711-.033-1.235-.283l-.762.762c.248.523.458.812.282 1.236-.176.424-.528.479-1.073.673v1.077c.544.193.897.25 1.073.673.177.427-.038.722-.282 1.236l.762.762c.521-.248.812-.458 1.235-.283.424.175.479.526.674 1.073h1.076c.194-.545.25-.897.676-1.074h.001c.421-.175.706.034 1.232.284l.762-.762c-.247-.521-.458-.812-.282-1.235s.529-.481 1.073-.674zm-4 .794c-.736 0-1.333-.597-1.333-1.333s.597-1.333 1.333-1.333 1.333.597 1.333 1.333-.597 1.333-1.333 1.333zm-4 3.071v-.808c-.412-.147-.673-.188-.805-.505s.024-.533.212-.927l-.572-.571c-.389.186-.607.344-.926.212s-.359-.394-.506-.805h-.807c-.146.409-.188.673-.506.805-.317.132-.533-.024-.926-.212l-.572.571c.187.393.344.609.212.927-.132.318-.396.359-.805.505v.808c.408.145.673.188.805.505.133.32-.028.542-.212.927l.572.571c.39-.186.608-.344.926-.212.318.132.359.395.506.805h.807c.146-.409.188-.673.507-.805h.001c.315-.131.529.025.924.213l.572-.571c-.186-.391-.344-.609-.212-.927s.397-.361.805-.506zm-3 .596c-.552 0-1-.447-1-1s.448-1 1-1 1 .447 1 1-.448 1-1 1z' />
  </svg>
);

export const UnlockIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M8 10v-4c0-2.206 1.794-4 4-4 2.205 0 4 1.794 4 4v1h2v-1c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-13z' />
  </svg>
);

export const LockIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M18 10v-4c0-3.313-2.687-6-6-6s-6 2.687-6 6v4h-3v14h18v-14h-3zm-10 0v-4c0-2.206 1.794-4 4-4s4 1.794 4 4v4h-8z' />
  </svg>
);

export const DeleteIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M3 6v18h18v-18h-18zm5 14c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm4-18v2h-20v-2h5.711c.9 0 1.631-1.099 1.631-2h5.315c0 .901.73 2 1.631 2h5.712z' />
  </svg>
);

export const RenameIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M5 21h-5v-2h5v2zm3.424-5.718l4.402 4.399-5.826 1.319 1.424-5.718zm15.576-6.748l-9.689 9.804-4.536-4.536 9.689-9.802 4.536 4.534z' />
  </svg>
);

export const CloneIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M22 6v16h-16v-16h16zm2-2h-20v20h20v-20zm-24 17v-21h21v2h-19v19h-2zm18-8h-3v-3h-2v3h-3v2h3v3h2v-3h3v-2z' />
  </svg>
);

export const PhotosIcon = () => (
  <div className='tooltip-secondary bottom' data-tip='Search & add image'>
    <svg
      width='26'
      height='26'
      viewBox='0 0 26 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.12501 13C9.91744 13 11.375 11.5424 11.375 9.74995C11.375 7.95752 9.91744 6.49994 8.12501 6.49994C6.33258 6.49994 4.875 7.95752 4.875 9.74995C4.875 11.5424 6.33258 13 8.12501 13ZM8.12501 8.12497C9.02082 8.12497 9.74998 8.85413 9.74998 9.74995C9.74998 10.6458 9.02082 11.3749 8.12501 11.3749C7.22919 11.3749 6.50003 10.6458 6.50003 9.74995C6.50003 8.85413 7.22919 8.12497 8.12501 8.12497Z'
        fill='#000000'
        fillOpacity='0.5'
      />
      <path
        d='M25.1875 3.25H0.812515C0.363383 3.25 0 3.61338 0 4.06251V21.9375C0 22.3866 0.363383 22.75 0.812515 22.75H25.1875C25.6366 22.75 26 22.3866 26 21.9375V4.06251C26 3.61338 25.6366 3.25 25.1875 3.25ZM1.62498 4.87498H24.375V19.1635L16.8245 11.613C16.5071 11.2956 15.9929 11.2956 15.6756 11.613L6.16356 21.125H1.62498C1.62498 21.125 1.62498 4.87503 1.62498 4.87498ZM24.0386 21.125H8.46144L16.25 13.3364C16.25 13.3364 24.0386 21.125 24.0386 21.125Z'
        fill='#000000'
        fillOpacity='0.5'
      />
    </svg>
  </div>
);

export const TextIcon = () => (
  <div className='tooltip-secondary bottom' data-tip='Insert text'>
    <svg
      width='27'
      height='26'
      viewBox='0 0 27 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5.60889 10.7148H10.1792V9.19141H11.7026V16.8086H10.1792V21.3789H17.7964V16.8086H16.273V9.19141H17.7964V10.7148H22.3667V4.62109H5.60889V10.7148ZM7.13232 6.14453H20.8433V9.19141H19.3198V7.66797H14.7495V18.332H16.273V19.8555H11.7026V18.332H13.2261V7.66797H8.65576V9.19141H7.13232V6.14453Z'
        fill='#000000'
        fillOpacity='0.5'
      />
      <path
        d='M26.9878 4.57031V0H22.4175V1.52344H5.55811V0H0.987793V4.57031H2.51123V21.4297H0.987793V26H5.55811V24.4766H22.4175V26H26.9878V21.4297H25.4644V4.57031H26.9878ZM23.9409 1.52344H25.4644V3.04688H23.9409V1.52344ZM2.51123 1.52344H4.03467V3.04688H2.51123V1.52344ZM4.03467 24.4766H2.51123V22.9531H4.03467V24.4766ZM25.4644 24.4766H23.9409V22.9531H25.4644V24.4766ZM23.9409 21.4297H22.4175V22.9531H5.55811V21.4297H4.03467V4.57031H5.55811V3.04688H22.4175V4.57031H23.9409V21.4297Z'
        fill='#000000'
        fillOpacity='0.5'
      />
    </svg>
  </div>
);

export const UploadIcon = () => (
  <div className='tooltip-secondary bottom' data-tip='Upload image'>
    <svg
      width='26'
      height='26'
      viewBox='0 0 26 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M20.9977 7.76498C20.1195 3.35892 15.8359 0.4991 11.4298 1.37726C8.20716 2.01956 5.68734 4.5378 5.04306 7.76003C1.91902 8.12006 -0.321905 10.9444 0.0379281 14.0686C0.369196 16.9439 2.80451 19.1132 5.69885 19.1112H9.76611C10.2154 19.1112 10.5796 18.747 10.5796 18.2977C10.5796 17.8484 10.2154 17.4842 9.76611 17.4842H5.69885C3.45237 17.4709 1.6423 15.6393 1.65539 13.393C1.66868 11.1467 3.50038 9.33643 5.74685 9.34952C6.16143 9.34972 6.50976 9.03769 6.55538 8.62569C6.96838 5.05533 10.1975 2.49583 13.7679 2.90883C16.7696 3.25617 19.1374 5.62384 19.4846 8.62569C19.5528 9.04503 19.9162 9.3523 20.3411 9.34952C22.5876 9.34952 24.4086 11.1705 24.4086 13.417C24.4086 15.6633 22.5876 17.4842 20.3411 17.4842H16.2738C15.8245 17.4842 15.4604 17.8484 15.4604 18.2977C15.4604 18.747 15.8245 19.1112 16.2738 19.1112H20.3413C23.486 19.0916 26.0195 16.5265 26 13.3817C25.9822 10.5179 23.8402 8.11292 20.9977 7.76498Z'
        fill='#000000'
        fillOpacity='0.5'
      />
      <path
        d='M15.8954 15.8166C16.2076 16.1399 16.7226 16.1489 17.0457 15.8366C17.3689 15.5246 17.3778 15.0097 17.0658 14.6865C17.0592 14.6796 17.0525 14.673 17.0457 14.6665L13.5958 11.2157C13.2786 10.8976 12.7634 10.897 12.4453 11.2142C12.4449 11.2147 12.4443 11.2151 12.4439 11.2157L8.99393 14.6665C8.6708 14.9785 8.66187 15.4935 8.9739 15.8166C9.28612 16.1397 9.80108 16.1487 10.1242 15.8366C10.131 15.8301 10.1377 15.8233 10.1442 15.8166L12.2064 13.7536V23.992C12.2064 24.4413 12.5706 24.8055 13.0199 24.8055C13.469 24.8055 13.8332 24.4413 13.8332 23.992V13.7536L15.8954 15.8166Z'
        fill='#000000'
        fillOpacity='0.5'
      />
    </svg>
  </div>
);

export const ElementsIcon = () => (
  <div className='tooltip-secondary bottom' data-tip='Insert elements'>
    <svg
      width='27'
      height='26'
      viewBox='0 0 27 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M26.5654 13.7126L20.8965 10.9731V3.68361C20.8965 3.38964 20.7273 3.12192 20.4619 2.99573L14.3174 0.0738305C14.1096 -0.0249896 13.8683 -0.0245834 13.6609 0.0748969L7.56721 2.99679C7.3065 3.12187 7.13541 3.38923 7.13491 3.68168C7.13491 3.68234 7.13486 3.683 7.13486 3.68366V10.9566L1.42106 13.7123C1.16147 13.8376 0.990234 14.1043 0.990234 14.3984V22.1497C0.990234 22.4374 1.15233 22.7006 1.40933 22.83L7.54182 25.9185C7.77394 26.0354 8.07857 26.0318 8.31785 25.8726L13.9896 23.0037L19.727 25.9174C19.9588 26.0351 20.2621 26.0321 20.5014 25.875L26.5752 22.8307C26.8329 22.7016 26.9855 22.438 26.9855 22.1497V14.3984C26.9855 14.1062 26.8266 13.839 26.5654 13.7126ZM7.13475 24.0078L2.51367 21.6805V15.635L7.13475 17.9623V24.0078ZM7.88368 16.6337L3.47475 14.4132L7.8949 12.2813L12.2737 14.4131L7.88368 16.6337ZM13.2285 21.6814L8.65819 23.9932V17.9492L13.2285 15.6374V21.6814ZM13.2285 13.181L8.65819 10.9583V4.92363L13.2285 7.24007V13.181ZM9.61877 3.70255L13.9916 1.60585L18.3877 3.6963L13.9907 5.91844L9.61877 3.70255ZM19.373 4.9052V10.9416L14.7519 13.1825V7.24063L19.373 4.9052ZM19.3222 24.0032L14.7519 21.6822V15.6396L19.3222 17.9606V24.0032ZM20.0741 16.6338L15.7096 14.4173L20.1179 12.2888L24.5091 14.4109L20.0741 16.6338ZM25.4721 21.6795L20.8457 23.9984V17.9512L25.4721 15.6323V21.6795Z'
        fill='#000000'
        fillOpacity='0.5'
      />
    </svg>
  </div>
);

export const ShowIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12.015 7c4.751 0 8.063 3.012 9.504 4.636-1.401 1.837-4.713 5.364-9.504 5.364-4.42 0-7.93-3.536-9.478-5.407 1.493-1.647 4.817-4.593 9.478-4.593zm0-2c-7.569 0-12.015 6.551-12.015 6.551s4.835 7.449 12.015 7.449c7.733 0 11.985-7.449 11.985-7.449s-4.291-6.551-11.985-6.551zm-.015 3c-2.209 0-4 1.792-4 4 0 2.209 1.791 4 4 4s4-1.791 4-4c0-2.208-1.791-4-4-4z' />
  </svg>
)

export const ShowIconImg = () => (
  <img style={{ width: '2.5rem', height: 'auto' }} src={eyeImg} alt="Show" />
)

export const NewIconImg = () => (
  <img style={{ width: '2.5rem', height: 'auto' }} src={newImg} alt="New" />
)

export const HideIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M19.604 2.562l-3.346 3.137c-1.27-.428-2.686-.699-4.243-.699-7.569 0-12.015 6.551-12.015 6.551s1.928 2.951 5.146 5.138l-2.911 2.909 1.414 1.414 17.37-17.035-1.415-1.415zm-6.016 5.779c-3.288-1.453-6.681 1.908-5.265 5.206l-1.726 1.707c-1.814-1.16-3.225-2.65-4.06-3.66 1.493-1.648 4.817-4.594 9.478-4.594.927 0 1.796.119 2.61.315l-1.037 1.026zm-2.883 7.431l5.09-4.993c1.017 3.111-2.003 6.067-5.09 4.993zm13.295-4.221s-4.252 7.449-11.985 7.449c-1.379 0-2.662-.291-3.851-.737l1.614-1.583c.715.193 1.458.32 2.237.32 4.791 0 8.104-3.527 9.504-5.364-.729-.822-1.956-1.99-3.587-2.952l1.489-1.46c2.982 1.9 4.579 4.327 4.579 4.327z' />
  </svg>
);

export const BoxIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M22 2v20h-20v-20h20zm2-2h-24v24h24v-24z' />
  </svg>
);

export const ImageIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M5 8.5c0-.828.672-1.5 1.5-1.5s1.5.672 1.5 1.5c0 .829-.672 1.5-1.5 1.5s-1.5-.671-1.5-1.5zm9 .5l-2.519 4-2.481-1.96-4 5.96h14l-5-8zm8-4v14h-20v-14h20zm2-2h-24v18h24v-18z' />
  </svg>
);

export const CheckIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M0 0v24h24v-24h-24zm10.041 17l-4.5-4.319 1.395-1.435 3.08 2.937 7.021-7.183 1.422 1.409-8.418 8.591z' />
  </svg>
);

export const PartialIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M22 2v20h-20v-20h20zm2-2h-24v24h24v-24zm-6 6h-12v12h12v-12z' />
  </svg>
);

export const PlusIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M24 10h-10v-10h-4v10h-10v4h10v10h4v-10h10z' />
  </svg>
);

export const StarIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z' />
  </svg>
);
export const LongArrowLeftIcon = () => (
  <svg
    width='24'
    height='20'
    viewBox='0 0 384 321'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M368 145H48.808L171.032 28.584C177.432 22.488 177.68 12.36 171.584 5.96C165.496 -0.432005 155.368 -0.688007 148.96 5.40799L9.376 138.368C3.336 144.416 0 152.448 0 161C0 169.544 3.336 177.584 9.656 183.896L148.968 316.584C152.064 319.536 156.032 321 160 321C164.224 321 168.448 319.336 171.592 316.032C177.688 309.632 177.44 299.512 171.04 293.416L48.304 177H368C376.832 177 384 169.832 384 161C384 152.168 376.832 145 368 145V145Z' />
  </svg>
);

export const LongArrowRightIcon = () => (
  <svg
    width='24'
    height='20'
    viewBox='0 0 384 321'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M16 145H335.192L212.968 28.584C206.568 22.488 206.32 12.36 212.416 5.96C218.504 -0.432005 228.632 -0.688007 235.04 5.40799L374.624 138.368C380.664 144.416 384 152.448 384 161C384 169.544 380.664 177.584 374.344 183.896L235.032 316.584C231.936 319.536 227.968 321 224 321C219.776 321 215.552 319.336 212.408 316.032C206.312 309.632 206.56 299.512 212.96 293.416L335.696 177H16C7.168 177 0 169.832 0 161C0 152.168 7.168 145 16 145V145Z' />
  </svg>
);
export const SingleDesignIcon = () => (
  <svg viewBox='0 0 140 133' xmlns='http://www.w3.org/2000/svg'>
    <g
      id='CREATE-NEW-FINAL'
      fill='none'
      fillRule='evenodd'
      stroke='none'
      strokeWidth='1'
    >
      <g id='Artboard' transform='translate(-399 -595)'>
        <g id='Group-380-Copy' transform='translate(399 595)'>
          <g id='Group-20' transform='translate(0 1.9)'>
            <path
              id='Fill-1'
              fill='#F3F3F7'
              d='M115.477 21.025C106.743 11.93 95.213 5.553 82.919 2.542 68.894-.893 53.947-.045 40.153 4.217c-8.771 2.71-24.38 10.808-32.643 22.385-6.709 9.4-8.612 22.153-5.278 33.26 2.108 7.02 5.508 12.106 4.182 19.833-.654 3.81-2.28 7.281-2.314 11.26-.062 7.349 2.548 14.482 6.328 20.71a58.476 58.476 0 003.815 5.521c1.186 1.525 3.747 5.475 10.695 9.407 5.368 3.037 11.78 4.553 19.353 4.04 18.519-1.258 35.297-12.73 51.577-21.195 31.29-16.27 41.44-31.208 41.44-49.251 0-15.442-8.45-29.359-21.831-39.162'
            ></path>
            <path
              id='Combined-Shape'
              fill='#CBCED7'
              d='M86.537 91.937c3.074-1.59 6.253-1.315 9.43-.278 3.48 1.136 6.985 2.453 10.075 4.441.66.425 1.3.883 1.917 1.378 1.136.912 2.183 1.955 3.007 3.15-4.372 2.91-9.382 5.838-15.098 8.81-4.474 2.326-8.986 4.88-13.561 7.386a12.16 12.16 0 01-1.919-3.829c-1.152-3.89-.881-8.16.043-12.067.814-3.436 2.333-6.711 5.466-8.63.209-.127.422-.248.64-.361z'
            ></path>
            <path
              id='Combined-Shape'
              fill='#7C7F8C'
              d='M15.534 98.683c2.1 7.014 5.085 13.795 11.065 17.662 6.843 4.424 17.783 5.09 25.43 2.58l-.307.402-8.693 11.373c-7.026.272-13.024-1.24-18.091-4.107-6.948-3.932-9.509-7.882-10.695-9.407a58.476 58.476 0 01-3.815-5.522 51.898 51.898 0 01-1.717-3.052z'
            ></path>
            <path
              id='Fill-11'
              fill='#FFF'
              d='M66.362 80.183c-6.746-1.277-12.871-5.623-15.837-11.97L33.09 74.96a5.93 5.93 0 00-2.59 1.96c3.535 1.635 3.188 6.64.968 10.459s-4.665 10.417-.39 12.013c5.703 1.748 11.003-4.865 15.82-3.695 1.13.274 2.374.978 2.798 3.3.51 2.784.085 5.185 1.688 7.313 1.618 2.072 3.537 2.45 5.582 1.997 4.355-.812 6.782-3.304 7.993-5.266.814-1.318 1.077-2.29 1.257-3.307.131-.742.146-1.863.146-1.863V80.183z'
            ></path>
            <path
              id='Fill-8'
              fill='#8A8E9B'
              d='M52.192 104.835c-1.603-2.128-.681-4.341-1.75-7.002-.851-1.187-2.152-2.507-3.056-2.9-4.767-2.074-9.568 5.437-15.407 3.648-4.275-1.596-1.68-6.92.457-10.645 1.424-3.308 1.955-9.774-1.937-11.016-.053.07-.108.139-.158.211L17.426 95.93l-1.892 2.754c1.233 9.953 4.474 16.722 13.274 20.99 4.274 2.661 13.44 3.691 18.25 2.094 1.922-.582 3.488-1.475 4.971-2.844l9.692-12.68c-3.746 2.129-6.694 2.221-9.529-1.409'
            ></path>
            <path
              id='Fill-6'
              fill='#48494F'
              d='M64.651 62.746l-14.126 5.467c2.966 6.347 9.09 10.693 15.837 11.97v-16.27c0-.88-.888-1.485-1.711-1.167'
            ></path>
          </g>
          <g id='Group-379' fill='#48494F' transform='translate(83.6 83.6)'>
            <path
              id='Fill-347'
              d='M3.58 19.083c0 .819-.667 1.483-1.49 1.483a1.486 1.486 0 01-1.488-1.483c0-.82.666-1.484 1.488-1.484.823 0 1.49.664 1.49 1.484'
            ></path>
            <path
              id='Fill-349'
              d='M11.391 14.02c0 .82-.666 1.483-1.489 1.483a1.485 1.485 0 01-1.488-1.483c0-.82.665-1.483 1.488-1.483s1.49.664 1.49 1.483'
            ></path>
            <path
              id='Fill-351'
              d='M19.203 8.958c0 .819-.666 1.483-1.489 1.483a1.486 1.486 0 01-1.489-1.483c0-.82.666-1.484 1.49-1.484.822 0 1.488.664 1.488 1.484'
            ></path>
            <path
              id='Fill-353'
              d='M6.247 6.553c0 .82-.667 1.483-1.49 1.483A1.485 1.485 0 013.27 6.553c0-.82.666-1.484 1.489-1.484.822 0 1.489.665 1.489 1.484'
            ></path>
            <path
              id='Fill-355'
              d='M14.059 1.49c0 .82-.667 1.484-1.489 1.484-.823 0-1.49-.664-1.49-1.483 0-.82.667-1.484 1.49-1.484.822 0 1.489.664 1.489 1.484'
            ></path>
            <path
              id='Fill-357'
              d='M27.016 3.896c0 .819-.667 1.483-1.49 1.483-.822 0-1.489-.664-1.489-1.483 0-.82.667-1.484 1.49-1.484.822 0 1.489.664 1.489 1.484'
            ></path>
            <path
              id='Fill-359'
              d='M8.66 26.803c0 .819-.666 1.483-1.488 1.483-.823 0-1.49-.664-1.49-1.483 0-.82.667-1.484 1.49-1.484.822 0 1.488.664 1.488 1.484'
            ></path>
            <path
              id='Fill-361'
              d='M16.472 21.74c0 .82-.666 1.483-1.489 1.483a1.485 1.485 0 01-1.488-1.482c0-.82.666-1.484 1.488-1.484.823 0 1.49.664 1.49 1.484'
            ></path>
            <path
              id='Fill-363'
              d='M24.284 16.678c0 .819-.666 1.483-1.489 1.483a1.486 1.486 0 01-1.488-1.483c0-.82.665-1.484 1.488-1.484s1.49.665 1.49 1.484'
            ></path>
            <path
              id='Fill-365'
              d='M32.096 11.616c0 .819-.666 1.483-1.489 1.483a1.486 1.486 0 01-1.489-1.483c0-.82.666-1.484 1.49-1.484.822 0 1.488.664 1.488 1.484'
            ></path>
            <path
              id='Fill-367'
              d='M13.741 34.523c0 .819-.666 1.483-1.488 1.483-.823 0-1.49-.664-1.49-1.483 0-.82.667-1.484 1.49-1.484.822 0 1.488.665 1.488 1.484'
            ></path>
            <path
              id='Fill-369'
              d='M21.553 29.46c0 .82-.666 1.484-1.489 1.484-.822 0-1.49-.664-1.49-1.483 0-.82.668-1.484 1.49-1.484.823 0 1.49.664 1.49 1.484'
            ></path>
            <path
              id='Fill-371'
              d='M29.365 24.398c0 .819-.666 1.483-1.489 1.483a1.486 1.486 0 01-1.488-1.483c0-.82.666-1.484 1.488-1.484.823 0 1.49.665 1.49 1.484'
            ></path>
            <path
              id='Fill-373'
              d='M37.177 19.336c0 .819-.666 1.483-1.489 1.483a1.486 1.486 0 01-1.488-1.483c0-.82.665-1.484 1.488-1.484s1.49.665 1.49 1.484'
            ></path>
          </g>
          <g id='Group-5' transform='translate(59.85)'>
            <path
              id='Fill-21'
              fill='#9497A5'
              d='M64.81 66.374a382.55 382.55 0 01-8.317-1.017 520.636 520.636 0 01-16.412-2.472c-4.264-.706-22.077-4.06-26.778-5.05-2.26-.475-4.632-1.06-6.314-2.738-1.724-1.719-2.427-4.3-2.774-6.79-.002-.01-3.973-30.533-4.031-33.264-.034-1.592-.049-3.328 1.095-4.988.778-1.126 1.826-1.634 2.928-1.96 1.394-.415 7.48-.964 9.061-1.15 5.27-.623 10.542-1.212 15.813-1.813 5.274-.602 10.548-1.214 15.815-1.883C52.931 2.23 60.968 1.004 69.024.199c4.566-.563 9.106.578 10.512 5.82.555 2.066.535 4.251.51 6.402-.024 2.035-.034 4.07-.038 6.105-.024 12.15-.313 24.25-.69 36.376-.082 2.605-.305 5.891-1.896 7.992-1.423 1.877-3.594 3.082-5.805 3.503-1.323.25-2.593.292-3.875.233a45.777 45.777 0 01-2.933-.256z'
            ></path>
            <path
              id='Fill-375'
              fill='#F3F5FF'
              d='M71.727 14.265l-30.208 2.232c-.29.022-.536-.24-.536-.572v-3.47c0-.3.202-.552.464-.58L71.65 8.719c.318-.033.59.238.59.59v4.353c0 .318-.224.582-.513.603'
              opacity='0.4'
            ></path>
            <path
              id='Fill-377'
              fill='#F3F5FF'
              d='M71.705 25.565l-30.207.446c-.283.004-.515-.26-.515-.586v-3.506c0-.312.214-.568.485-.581l30.204-1.38c.31-.014.569.26.569.606v4.399c0 .33-.238.597-.536.602'
              opacity='0.4'
            ></path>
            <path
              id='Rectangle'
              fill='#FFF'
              fillRule='nonzero'
              d='M55.093 31.2h16.21a.95.95 0 01.949.921l.096 3.276a.95.95 0 01-.962.978L55.08 36.16a.95.95 0 01-.937-.95v-3.062a.95.95 0 01.95-.95z'
            ></path>
            <ellipse
              id='Oval'
              cx='16.237'
              cy='19.958'
              fill='#F3F5FF'
              fillRule='nonzero'
              opacity='0.4'
              rx='5.644'
              ry='6.053'
            ></ellipse>
            <path
              id='Path'
              fill='#F3F5FF'
              fillRule='nonzero'
              d='M22.754 40.507l5.29 7.027a1.9 1.9 0 002.988.061l9.645-11.774a1.9 1.9 0 013.071.182l12.317 19.292a1.9 1.9 0 01-1.905 2.898L13.937 51.68a1.9 1.9 0 01-1.138-3.113l6.995-8.154a1.9 1.9 0 012.96.094z'
              opacity='0.4'
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const DesignSetIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 148 153'
    width='148'
    height='153'
  >
    <g fill='none' fillRule='evenodd' stroke='none' strokeWidth='1'>
      <g fillRule='nonzero' transform='translate(-952 -390)'>
        <g transform='translate(952 390)'>
          <path
            d='M146.767 97.154c-.877-2.899-1.954-5.499-3.28-8.204-1.352-2.758-2.54-5.632-3.077-8.671-1.414-8.016 2.081-14.89 4.46-22.319 4.086-12.756 1.127-26.487-7.693-36.756C122.405 4.005 98.26-3.065 76.34 1.222 64.383 3.56 53.106 8.59 42.402 14.42 27.076 22.765 12.02 33.596 4.722 49.476-2.426 65.029-.98 83.629 5.852 99.325 18.605 128.62 46.553 153 79.48 153c15.591 0 44.863-3.114 61.087-26.02 6.242-8.81 9.323-19.512 6.2-29.826'
            fill='#DFE0E6'
          ></path>
          <g transform='translate(90.455 17.43)'>
            <path
              fill='#8A8E9B'
              d='M6.293.059A4.98 4.98 0 00.544 4.982v85.563a4.987 4.987 0 005.231 4.972l30.099-4.307a4.99 4.99 0 004.747-4.98V9.707A4.99 4.99 0 0036.4 4.785L6.293.059z'
            ></path>
            <path
              fill='#FFF'
              d='M6.125 13.77c-.332-.04-.58-.305-.58-.616V7.837c0-.38.364-.673.769-.615l28.664 4.223c.326.047.567.309.567.616v4.8c0 .376-.356.667-.757.617L6.125 13.77z'
              opacity='0.4'
            ></path>
            <path
              fill='#FFF'
              d='M6.147 26.04c-.341-.032-.602-.298-.602-.614v-5.271c0-.37.349-.658.746-.614l28.664 3.247c.336.037.59.3.59.613v4.76c0 .365-.342.65-.735.614L6.147 26.04z'
              opacity='0.4'
            ></path>
            <path
              fill='#FFF'
              d='M26.095 41.096l-17.77-1.221c-1-.07-1.78-.941-1.78-1.995v-2.996c0-1.168.954-2.09 2.064-1.99l17.77 1.569c.987.087 1.745.953 1.745 1.99v2.649c0 1.154-.93 2.07-2.03 1.994'
            ></path>
            <g fill='#FFF' opacity='0.4' transform='translate(7.193 54.45)'>
              <path d='M11.434 2.16a1.541 1.541 0 11-3.082 0 1.541 1.541 0 013.082 0'></path>
              <path d='M25.934 2.66a1.541 1.541 0 11-3.082 0 1.541 1.541 0 013.082 0'></path>
              <path d='M11.434 16.916a1.54 1.54 0 11-3.08 0 1.54 1.54 0 013.08 0'></path>
              <path d='M26.434 16.661a1.54 1.54 0 11-3.08 0 1.54 1.54 0 013.08 0'></path>
              <path d='M18.934 9.661a1.541 1.541 0 11-3.082-.002 1.541 1.541 0 013.082.002'></path>
              <path d='M3.934 9.661A1.541 1.541 0 11.852 9.66a1.541 1.541 0 013.082.001'></path>
              <path d='M18.934 24.161a1.54 1.54 0 11-3.08 0 1.54 1.54 0 013.08 0'></path>
              <path d='M3.934 24.661a1.54 1.54 0 11-3.08 0 1.54 1.54 0 013.08 0'></path>
            </g>
          </g>
          <g transform='translate(12.331 73.933)'>
            <path
              fill='#8A8E9B'
              d='M66.22.058L37.346-.001H18.639c-2.717-.017-4.938 2.191-4.97 4.943v68.07a5.034 5.034 0 001.78 3.868 4.9 4.9 0 004.076 1.075l19.358-3.723 28.264-5.411c2.36-.431 4.074-2.514 4.067-4.942V5.015a5.031 5.031 0 00-1.48-3.528A4.905 4.905 0 0066.22.057z'
            ></path>
            <path
              fill='#7C7F8C'
              d='M13.669 73.224c0 3.115 2.824 5.461 5.874 4.883l20.843-4.275C35.604 59.735 23.824 45.737 13.67 35.067v38.157z'
            ></path>
            <path
              fill='#CBCED7'
              d='M16.163 41.423l8.372 13.966a2 2 0 003.39.064l14.66-22.478a2 2 0 013.447.162L65.196 69.63a2 2 0 01-2.123 2.899L2.32 61.663a2 2 0 01-1.3-3.097l11.777-17.242a2 2 0 013.367.1z'
              transform='matrix(-1 0 0 1 66.096 0)'
            ></path>
            <ellipse
              cx='53.169'
              cy='19.567'
              fill='#CBCED7'
              rx='5.5'
              ry='6.5'
              transform='matrix(-1 0 0 1 106.338 0)'
            ></ellipse>
          </g>
          <g transform='translate(25.717 6.161)'>
            <path
              fill='#8A8E9B'
              d='M24.605 59.753l28.133.829a4.904 4.904 0 003.594-1.428 5.085 5.085 0 001.496-3.62V12.615c-.003-2.48-1.778-4.59-4.186-4.973L5.982.058a4.89 4.89 0 00-3.97 1.155 5.077 5.077 0 00-1.73 3.818v49.11c.004 2.723 2.131 4.951 4.805 5.032l19.543.58'
            ></path>
            <path
              fill='#FFF'
              d='M49.743 23.13L7.839 18.444a.62.62 0 01-.556-.61l.002-5.38c0-.37.333-.658.708-.61l41.885 5.333a.62.62 0 01.547.607l.016 4.734a.624.624 0 01-.698.612'
              opacity='0.4'
            ></path>
            <path
              fill='#FFF'
              d='M38.456 33.078L7.858 30.513a.623.623 0 01-.575-.616l.002-5.44c0-.365.322-.651.692-.615l30.584 3.042c.32.031.564.297.565.615l.012 4.961a.625.625 0 01-.682.618'
              opacity='0.4'
            ></path>
            <path
              fill='#FFF'
              d='M7.283 39.782v4.43c0 1.04 1 1.894 2.273 1.942l25.039.925c1.356.05 2.488-.834 2.488-1.942v-3.904c0-1.02-.965-1.865-2.212-1.938L9.832 37.844c-1.378-.08-2.55.811-2.55 1.938'
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const CollapseBgIcon = () => (
  <svg viewBox='0 0 32 112' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M22.626 17.865l-1.94-1.131C17.684 14.981 16 12.608 16 10.133V0H0v112h16v-10.135c0-2.475 1.684-4.849 4.686-6.6l1.94-1.131C28.628 90.632 32 85.885 32 80.934v-49.87c0-4.95-3.372-9.698-9.374-13.199'
      fill='#293039'
    ></path>
  </svg>
);

export const HamburgerIcon = () => (
  <svg
    width="24"
    height="24"
    xmlns="http://www.w3.org/2000/svg"
    fillRule="evenodd"
    clipRule="evenodd"
  >
    <path
      d="M24 18v1h-24v-1h24zm0-6v1h-24v-1h24zm0-6v1h-24v-1h24z"
      fill="#1040e2"
    />
    <path d="M24 19h-24v-1h24v1zm0-6h-24v-1h24v1zm0-6h-24v-1h24v1z" />
  </svg>
);

export const TickIcon = () => (
  <img style={{ width: '2.5rem', height: 'auto' }} src={tickImg} alt="tickicon" />
)

export const ImageIconLayer = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="#2F80ED"/>
    <path d="M22 14L18.25 19L21.1 22.8L19.5 24C17.81 21.75 15 18 15 18L9 26H31L22 14Z" fill="white"/>
  </svg>
  // <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  //   <path fill-rule="evenodd" clip-rule="evenodd" d="M12 14L4 14C2.89533 14 2 13.1047 2 12L2 4C2 2.89533 2.89533 2 4 2L12 2C13.1047 2 14 2.89533 14 4L14 12C14 13.1047 13.1047 14 12 14Z" stroke="#152370" stroke-linecap="round" stroke-linejoin="round"/>
  //   <path d="M6.65861 5.0087C7.11423 5.46431 7.11423 6.20301 6.65861 6.65861C6.203 7.11423 5.46431 7.11423 5.0087 6.65861C4.55309 6.203 4.55309 5.46431 5.0087 5.0087C5.46431 4.55309 6.20301 4.55309 6.65861 5.0087" stroke="#152370" stroke-linecap="round" stroke-linejoin="round"/>
  //   <path d="M14.0003 6.73966C13.7003 6.69699 13.3957 6.66699 13.0837 6.66699C9.53966 6.66699 6.66699 9.53966 6.66699 13.0837C6.66699 13.3957 6.69699 13.7003 6.73966 14.0003" stroke="#152370" stroke-linecap="round" stroke-linejoin="round"/>
  // </svg>
)

export const TextLayerIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="#219653"/>
    <path d="M29 15V11H25V12H15V11H11V15H12V25H11V29H15V28H25V29H29V25H28V15H29ZM26 12H28V14H26V12ZM12 12H14V14H12V12ZM14 28H12V26H14V28ZM28 28H26V26H28V28ZM26 25H25V26H15V25H14V15H15V14H25V15H26V25ZM24 16V18H21V24H19V18H16V16H24Z" fill="white"/>
  </svg>
  // <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  //   <g clip-path="url(#clip0)">
  //     <rect x="5.63301" y="3.0998" width="0.6" height="10.0667" fill="#4253A9" stroke="#152370" stroke-width="0.6"/>
  //     <rect x="1.63301" y="3.56621" width="0.6" height="8.52" transform="rotate(-90 1.63301 3.56621)" fill="#4253A9" stroke="#152370" stroke-width="0.6"/>
  //     <rect x="10.967" y="7.0998" width="0.6" height="6.06667" fill="#4253A9" stroke="#152370" stroke-width="0.6"/>
  //     <rect x="8.3" y="7.56621" width="0.6" height="5.71333" transform="rotate(-90 8.3 7.56621)" fill="#4253A9" stroke="#152370" stroke-width="0.6"/>
  //   </g>
  //   <defs>
  //     <clipPath id="clip0">
  //       <rect width="13.3333" height="13.3333" fill="white" transform="translate(1.33301 1.33301)"/>
  //     </clipPath>
  //   </defs>
  // </svg>
)

export const EditIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="white"
    >
      <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-5 17l1.006-4.036 3.106 3.105-4.112.931zm5.16-1.879l-3.202-3.202 5.841-5.919 3.201 3.2-5.84 5.921z" />
    </svg>
);

export const OverlineIcon = () => (
  <div className="tooltip-secondary top" data-tip="Insert Upper bar">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      aria-hidden="true"
      focusable="false"
      width="1em"
      height="1em"
      preserveAspectRatio="xMidYMid meet"
      viewBox="0 0 24 24"
    >
      <path
        d="M5 5h14V3H5v2m4.62 11L12 9.67L14.37 16M11 7L5.5 21h2.25l1.12-3h6.25l1.13 3h2.25L13 7h-2z"
        fill="white"
      />
    </svg>
  </div>
);

export const NoImageIcon = () => (
  <svg width="98" height="98" viewBox="0 0 98 98" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M85.75 20.4167V47.3258L73.5 35.035L57.1667 51.4092L40.8333 35.0758L24.5 51.4092L12.25 39.1183V20.4167C12.25 18.2507 13.1104 16.1735 14.642 14.642C16.1735 13.1104 18.2507 12.25 20.4167 12.25H77.5833C79.7493 12.25 81.8265 13.1104 83.358 14.642C84.8896 16.1735 85.75 18.2507 85.75 20.4167ZM73.5 46.6317L85.75 58.9225V77.5833C85.75 79.7493 84.8896 81.8265 83.358 83.358C81.8265 84.8896 79.7493 85.75 77.5833 85.75H20.4167C18.2507 85.75 16.1735 84.8896 14.642 83.358C13.1104 81.8265 12.25 79.7493 12.25 77.5833V50.715L24.5 62.9242L40.8333 46.5908L57.1667 62.9242" fill="#E5E5E5"/>
  </svg>
)
